import { StateCreator } from 'zustand';
import { profileChangeProfileAvatar } from 'api/generated/endpoints/profile/profile';
import { AuthStore, AuthProfile } from '../types';

export const createProfileSlice: StateCreator<AuthStore, [], [], AuthProfile> = (set) => ({
    //? O erro aparece pelo toast do mutator (Orval 03); aqui só devolve se deu certo
    updateProfilePhoto: async (file: File) => {
        try {
            const updatedRelation = await profileChangeProfileAvatar({ Image: file });
            set((state) => ({
                data: state.data ? { ...state.data, relationData: updatedRelation } : null,
            }));
            return true;
        } catch {
            return false;
        }
    },
});
